export default class AdminsByCategoryPieService {
  constructor($http) {
    'ngInject';

    Object.assign(this, {
      $http
    });
  }

  getReport(params) {
    const pData = this.$http.get('/api/report/data_c_admin', {
      params: {
        chartType: 'pie',
        ...params
      }
    });

    const pDrilldown = this.$http.get('/api/report/data_c_a_admin', {
      params: {
        chartType: 'pie',
        ...params
      }
    });

    return Promise.all([pData, pDrilldown])
      .then(([pDataResult, pDrilldownResult]) => {
        const series = pDataResult.data;
        const drilldown = { series: pDrilldownResult.data };

        return { series, drilldown };
      });
  }
}



// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-pie/admins-by-category-pie.service.js